/** Valid (implemented) formatter locales. */
// TODO Replace with import once formatter context created.
export type FormatterLocale = 'en-GB' | 'en-US';

export enum Auth0Region {
  EU = 'eu',
  US = 'us',
}
